export const TARRIF_UPDATED_SHOWED_KEY = "TARRIF_UPDATED_SHOWED_KEY";
